import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule, Http, Response, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

//////////////////////////////////////////
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import { timeout } from 'rxjs/operator/timeout';


@Injectable()
export class RestApiProvider {

  private apiUrl = '';
  //private urlDesa = 'https://api-tantealogarage.syncashop.com/webservices'; [BACKUP ENVIROMENT]
  private urlDesa = 'https://api-tantealogarage.syncashop.com/webservices';

  constructor(public http: HttpClient) {
    console.log('Hello RestApiProvider Provider');
  }
//USER LOGIN
  login(username, password) {
    console.log('imprimiendo ruta login desde provider');
    console.log(this.urlDesa + "/login_service.php?username=" + username + "&password=" + password);
    return this.http.get(this.urlDesa + "/login_service.php?username=" + username + "&password=" + password)
      .timeout(8000)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;

  }
  //RECUPERAR PASSWORD
  sendEmail(email_user){
    console.log('imprimiendo ruta login desde provider');
    console.log(this.urlDesa + "/temp_retrieve_password_service.php?username=" + email_user );
    return this.http.get(this.urlDesa + "/temp_retrieve_password_service.php?username=" + email_user )
    .timeout(6000)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;

  }

//PERFIL
listar_vehiculos(id_usuario){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/lista_preferencias_service.php?id_usuario=" + id_usuario));
  return this.http.get(this.urlDesa + "/lista_preferencias_service.php?id_usuario=" + id_usuario)
    .timeout(8000)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

select_marca(){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/busqueda/marca-vehiculo.php"));
  return this.http.get(this.urlDesa + "/busqueda/marca-vehiculo.php")
    .timeout(8000)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

buscaModelo(marca){
  console.log('ruta metodo obtener modelos');
  console.log(this.urlDesa + "/vehiculos/buscaModelo.php", marca);
  return this.http.post(this.urlDesa + "/vehiculos/buscaModelo.php", marca)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

buscarCilindros(data){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/vehiculos/buscaCilindrada.php?ve=" + data));
  return this.http.get(this.urlDesa + "/vehiculos/buscaCilindrada.php?ve=" + data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

buscarLitros(data){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/vehiculos/buscaLitros.php?ve=" + data));
  return this.http.get(this.urlDesa + "/vehiculos/buscaLitros.php?ve=" + data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

buscarCajas(data){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/vehiculos/buscaCaja.php?ve=" + data));
  return this.http.get(this.urlDesa + "/vehiculos/buscaCaja.php?ve=" + data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

buscarYears(data){
  console.log('imprimiendo ruta viewProfile desde provider');
  console.log(this.http.get(this.urlDesa + "/vehiculos/buscaVehiculoYear.php?ve=" + data));
  return this.http.get(this.urlDesa + "/vehiculos/buscaVehiculoYear.php?ve=" + data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

registerVehicle(data){
  console.log('ruta metodo obtener modelos');
  console.log(this.urlDesa + "/obtener-datos-post.php", data);
  return this.http.post(this.urlDesa + "/obtener-datos-post.php", data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

eliminarVehicle(id_usuario, id_complemento){
  console.log('imprimiendo ruta desde provider');
  console.log(this.http.get(this.urlDesa + "/quitar_preferencia_service.php?id_usuario="+id_usuario+"&tipo_form=1&id="+id_complemento+""));
  return this.http.get(this.urlDesa + "/quitar_preferencia_service.php?id_usuario="+id_usuario+"&tipo_form=1&id="+id_complemento+"")
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}
//VEHICLE UPDATE ROUTINE (POST METHOD)
updateUserVehicle(data){
  console.log('ruta metodo actualizar vehiculo');
  console.log(this.urlDesa + "/update_user_vehicle.php", data);
  return this.http.post(this.urlDesa + "/update_user_vehicle.php", data)
    .map((results: Response) => results)
    .do((res: Response) => res /*console.log(res)*/)
    .catch(this.handleError)
    ;
}

//HOME
  obtener_promo_home_services(id_usuario) {
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/obtener_promo_home_services.php?id_usuario=" + id_usuario));
    return this.http.get(this.urlDesa + "/obtener_promo_home_services.php?id_usuario=" + id_usuario)
      .timeout(10000)
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ;

  }

  perfilProv(data) {
    //console.log((this.urlDesa + "/lista_tiendas.php?", data));
    return this.http.post(this.urlDesa + "/lista_tiendas.php?", data)
      .timeout(10000)
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ;
  }

  //RECOMENDADOS
  recomendados(id_usuario) {
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/obtener_promo_home_services.php?id_usuario=" + id_usuario));
    return this.http.get(this.urlDesa + "/obtener_promo_home_services.php?id_usuario=" + id_usuario)
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ;

  } 

  //REGISTER USER
registernewUser(email_user,password,name,last_name,cellnumber,region,city){
  console.log('imprimiendo ruta registo desde provider');
  console.log(this.urlDesa + "/register_user_service.php?username=" + email_user + "&password=" + password + "&nombre=" + name 
  + "&apellido=" + last_name + "&telefono=" + cellnumber + "&estado=" + region + "&municipio="+ city );
  return this.http.get(this.urlDesa + "/register_user_service.php?username=" + email_user + "&password=" + password + "&nombre=" + name 
  + "&apellido=" + last_name + "&telefono=" + cellnumber + "&estado=" + region + "&municipio="+ city + "&gcm_id=" + null)
    .timeout(8000)
    .map((results: Response) => results)
    .do((res: Response) => JSON.stringify(res) /*console.log(res)*/)
    .catch(this.handleError)
    ;
           
  }

   //REGISTER USER SUBROUTINES
            
            //----------------GET REGIONS FROM API---------------------
            getRegions(){
              console.log('imprimiendo ruta regiones desde provider');
              console.log(this.urlDesa + "/estados.php");
              return this.http.get(this.urlDesa + "/estados.php")
                .map((results: Response) => results)
                .do((res: Response) => /*res*/ console.log(res))
                .catch(this.handleError)
                ;
           

            }

            getCities(region){
              console.log('imprimiendo ruta regiones desde provider');
              console.log(this.urlDesa + "/estados.php?id_estado=" + region);
              return this.http.get(this.urlDesa + "/estados.php?id_estado=" + region)
                .map((results: Response) => results)
                .do((res: Response) => /*res*/ console.log(res))
                .catch(this.handleError)
                ;
           

            }

            //----------------------SEND REGISTER CONFIRMATION EMAIL-----------------------
            sendConfirmationEmail(email_user){
              console.log('imprimiendo ruta [email  confirmation] desde provider');
              console.log(this.urlDesa + "/enviar_email_confirm_registro.php?username=" + email_user);
              return this.http.get(this.urlDesa + "/enviar_email_confirm_registro.php?username=" + email_user)
                .map((results: Response) => results)
                .do((res: Response) => /*res*/ console.log(res))
                .catch(this.handleError)
                ;
           

            }

  //UPDATE USER PASSWORD

updatePass(oldPass,newPass,sessionID){
  console.log('imprimiendo ruta regiones desde provider');
  console.log(this.urlDesa + "/cambiar_contrasena.php?contrasena=" + oldPass + "&nueva=" + newPass + "&id_usuario=" + sessionID);
  return this.http.get(this.urlDesa + "/cambiar_contrasena.php?contrasena=" + oldPass + "&nueva=" + newPass + "&id_usuario=" + sessionID)
    .map((results: Response) => results)
    .do((res: Response) => /*res*/ console.log(res))
    .catch(this.handleError)
    ;


}
//BUSQUEDA
  productos(){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/busqueda/productos.php"));
    return this.http.get(this.urlDesa + "/busqueda/productos.php" )
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;
  }

  //SOLICITUDES
  temp_obtener_solicitudes_usuario(id_usuario){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/temp_obtener_solicitudes_usuario.php?id_usuario="+id_usuario));
    return this.http.get(this.urlDesa + "/temp_obtener_solicitudes_usuario.php?id_usuario="+id_usuario )
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  hide_solicitudes_prov(id_usuario, id_solicitud){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/hide_solicitudes_prov.php?id_usuario="+id_usuario+"&id_solicitud="+id_solicitud+" "));
    return this.http.get(this.urlDesa + "/hide_solicitudes_prov.php?id_usuario="+id_usuario+"&id_solicitud="+id_solicitud+" " )
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  solicitudes_prov_services(id_usuario){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/solicitudes_prov_services.php?id_usuario="+id_usuario));
    return this.http.get(this.urlDesa + "/solicitudes_prov_services.php?id_usuario="+id_usuario )
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  obtener_status_respuesta(id_usuario_prov, id_solicitud){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/obtener_status_respuesta.php?id_usuario_prov="+id_usuario_prov+"&id_solicitud="+id_solicitud));
    return this.http.get(this.urlDesa + "/obtener_status_respuesta.php?id_usuario_prov="+id_usuario_prov+"&id_solicitud="+id_solicitud)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  responder_solicitud_services(id,respuesta, id_usuario_prov, img, precio, metodopago, diasgarantia, fechaexpira, id_usuario_emisor, marcaProveedor ){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/responder_solicitud_services.php?id="+id+"&tipo_respuesta=undefined&respuesta="+respuesta+"&id_usuario_prov="+id_usuario_prov+"&img="+img+"&precio="+precio+"&metodopago="+metodopago+"&diasgarantia="+diasgarantia+"&fechaexpira="+fechaexpira+"&id_usuario_emisor="+id_usuario_emisor+"&marcaProveedor="+marcaProveedor+""));
    return this.http.get(this.urlDesa + "/responder_solicitud_services.php?id="+id+"&tipo_respuesta=undefined&respuesta="+respuesta+"&id_usuario_prov="+id_usuario_prov+"&img="+img+"&precio="+precio+"&metodopago="+metodopago+"&diasgarantia="+diasgarantia+"&fechaexpira="+fechaexpira+"&id_usuario_emisor="+id_usuario_emisor+"&marcaProveedor="+marcaProveedor+"")
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;
  }

  temp_obtener_respuestas_solicitudes_usuario(id_usuario, id_solicitud){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/temp_obtener_respuestas_solicitudes_usuario.php??id_usuario="+id_usuario+"&id_solicitud="+id_solicitud));
    return this.http.get(this.urlDesa + "/temp_obtener_respuestas_solicitudes_usuario.php??id_usuario="+id_usuario+"&id_solicitud="+id_solicitud)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  obtener_respuestas_solicitudes_usuario(id_usuario_prov, id_solicitud){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/tobtener_status_respuesta.php?id_usuario_prov="+id_usuario_prov+"&id_solicitud="+id_solicitud));
    return this.http.get(this.urlDesa + "/obtener_status_respuesta.php?id_usuario_prov="+id_usuario_prov+"&id_solicitud="+id_solicitud)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res)) 
      .catch(this.handleError)
      ;  
  }
  interes_oferta_cli(id, detalle2){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/interes_oferta_cli.php?id="+id+"&detalle2="+detalle2));
    return this.http.get(this.urlDesa + "/interes_oferta_cli.php?id="+id+"&detalle2="+detalle2)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  confirm_compra_cli(id, detalle2){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/confirm_compra_cli.php?id="+id+"&detalle2="+detalle2));
    return this.http.get(this.urlDesa + "/confirm_compra_cli.php?id="+id+"&detalle2="+detalle2)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ; 
  }

  confirm_compra_prov(id, id_usuario_prov){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/confirm_compra_prov.php?id="+id+"&id_usuario_prov="+id_usuario_prov));
    return this.http.get(this.urlDesa + "/confirm_compra_prov.php?id="+id+"&id_usuario_prov="+id_usuario_prov)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ; 
  }

  declinar_oferta_cli(detalle2, id){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/declinar_oferta_cli.php?detalle2="+detalle2+"&id="+id));
    return this.http.get(this.urlDesa + "/declinar_oferta_cli.php?detalle2="+detalle2+"&id="+id)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ; 
  }

  motivo_decli_oferta_cli(detalle2, id, motivo){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/motivo_decli_oferta_cli.php?detalle2="+detalle2+"&id="+id+"&motivo="+motivo));
    return this.http.get(this.urlDesa + "/motivo_decli_oferta_cli.php?detalle2="+detalle2+"&id="+id+"&motivo="+motivo)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ;  
  }

  lista_preferencias_service(id_usuario){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/lista_preferencias_service.php?id_usuario="+id_usuario));
    return this.http.get(this.urlDesa + "/lista_preferencias_service.php?id_usuario="+id_usuario)
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ; 
  }

  generar_solicitud(id_prod, id_cls, observacion, marcacliente,obligatoriamarca, usuario, marca_auto, modelo_auto, cilindros_auto, motor_auto, anio_auto, auto_id, auto_caja, imagen_referencia){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/generar_solicitud.php?id_prod="+id_prod+"&id_cls="+id_cls+"&id_linea=undefined&observacion="+observacion+"&preferencia=("+marca_auto+",%20Q5,%204L,%204,1,%202013,%203265,%20D)&marcacliente="+marcacliente+"&obligatoriamarca="+obligatoriamarca+"&usuario="+usuario+"&img="+imagen_referencia+" "));
    return this.http.get(this.urlDesa + "/generar_solicitud.php?id_prod="+id_prod+"&id_cls="+id_cls+"&id_linea=undefined&observacion="+observacion+"&preferencia=("+marca_auto+","+modelo_auto+" ,"+cilindros_auto+","+motor_auto+","+anio_auto+","+auto_id+","+auto_caja+")&marcacliente="+marcacliente+"&obligatoriamarca="+obligatoriamarca+"&usuario="+usuario+"&img="+imagen_referencia+" ")
      .map((results: Response) => results)
      .do((res: Response) => /*res*/ console.log(res))
      .catch(this.handleError)
      ; 
  }
  //INVENTARIO PROVEEDOR
  productosInventario(id_usuario, opcion){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/busqueda/productosInventario.php?id_usuario="+id_usuario+"&opcion="+opcion+" "));
    return this.http.get(this.urlDesa + "/busqueda/productosInventario.php?id_usuario="+id_usuario+"&opcion="+opcion+" ")
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ; 
  }

  productosAgregar(id_usuario, id_producto){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/busqueda/productosAgregar.php?id_usuario="+id_usuario+"&id_producto="+id_producto+"" ));
    return this.http.get(this.urlDesa + "/busqueda/productosAgregar.php?id_usuario="+id_usuario+"&id_producto="+id_producto+"" )
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ; 
  }

  productosEliminar(id_usuario, id_producto){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/busqueda/productosEliminar.php?id_usuario="+id_usuario+"&id_producto="+id_producto+" "));
    return this.http.get(this.urlDesa + "/busqueda/productosEliminar.php?id_usuario="+id_usuario+"&id_producto="+id_producto+" " )
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ; 
  }


  fetchQuestionStatus(id_solicitud){
    console.log('imprimiendo ruta viewProfile desde provider');
    console.log(this.http.get(this.urlDesa + "/obtener_status_pregunta.php?id_solicitud="+id_solicitud));
    return this.http.get(this.urlDesa + "/obtener_status_pregunta.php?id_solicitud="+id_solicitud)
      .map((results: Response) => results)
      .do((res: Response) => res /*console.log(res)*/)
      .catch(this.handleError)
      ; 
  }



  

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const err = error || '';
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/rest-api/rest-api.ts